import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyState1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 387.607,
	height: 186.584,
	viewBox: "0 0 387.607 186.584",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_4947",
		"data-name": "Group 4947",
		transform: "translate(-809.695 -323)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4738",
				"data-name": "Path 4738",
				d: "M4937.307,1294.672c2.031.015,3.379-1.429,4.794-2.492q9.028-6.783,18.35-13.146c.58-.394,1.37-.672,1.345-1.6,4.149-1.981,6.291-.8,6.383,3.524.032,1.476,0,2.951-.114,4.79,2.308-2.188,4.4-4.2,6.347-6.328a8.56,8.56,0,0,1,6.884-2.868c11.2.092,22.4.046,33.6.034,4.713-.005,4.958-.264,4.966-5.074.009-4.534-.083-9.071.038-13.6.063-2.329-.308-4.39-2-6.083,2.553-1.4,5.444-1.558,8.205-2.143a63.071,63.071,0,0,1,9.508-1.516c3.5-.194,6.95-.9,10.472-.757,2.218.091,4.443,0,6.665.021a147.545,147.545,0,0,1,17.016,1.543,139.474,139.474,0,0,1,17.569,3.505c9.189,2.4,18.4,4.9,26.986,9.05a47.869,47.869,0,0,1,15.265,12.1c5.708,6.583,10.433,13.816,15.333,20.958,5.732,8.354,11.358,16.8,17.9,24.559a153.261,153.261,0,0,0,16.34,16.529,148.66,148.66,0,0,0,20.707,14.712,45.032,45.032,0,0,1,13.649,12.382,33.393,33.393,0,0,1,5.611,13.979c1.284,7.731-.574,14.781-3.677,21.7a60.992,60.992,0,0,1-15.251,20.189,48.923,48.923,0,0,1-22.713,12.025,1.95,1.95,0,0,0-1.233.526c-.832.953-1.984.926-3.08.93q-19.151.067-38.3.007a6.518,6.518,0,0,1-2.451-.362c-1.333-.843-.459-1.324.351-1.632,1.55-.591,3.192-.925,4.725-1.578,4.048-1.724,5.549-4.128,5.131-8.438-1.307-13.491-2.384-27.01-4.913-40.355-1.324-6.988-2.715-13.95-5.431-20.57a16.932,16.932,0,0,0-1.758-3.434,13.19,13.19,0,0,0-6.993-5.546,161.307,161.307,0,0,1-30.734-15.774,6.862,6.862,0,0,1-2.492-2.147,75.056,75.056,0,0,1-2.746-10.462c.5-4.557,2.241-8.744,3.848-12.974,1.634-4.3,2.511-8.677,1.391-13.284a6.941,6.941,0,0,0-4.327-5.35,5.347,5.347,0,0,1-2.263-1.56c-3.7-4.518-8.722-4.889-13.91-4.22-5.793.747-11.307,2.709-16.842,4.505-1.873.608-2.816,2.08-1.49,3.565,3.294,3.686,2.905,7.9,2.488,12.244a9.908,9.908,0,0,0,.4,4.112,54.88,54.88,0,0,1,.212,7.133c-.038.617-.05,1.236-.054,1.853a18.538,18.538,0,0,0,.671,6.526c1.695,5.063,5.02,7.169,10.559,6.624,1.426-.141,2.884-.811,4.272.167a6.073,6.073,0,0,1,.82,4.814c-1.7,1.963-4.153,2.635-6.393,3.64-6.468,2.9-12.923,5.833-19.389,8.741-1.34.6-2.714,1.209-3.4,2.665-.949,1.985-1.662,4.064-2.458,6.112-4.863,13.394-8.516,27.155-12.476,40.822-1.105,3.815-2.24,7.623-3.52,11.388a10.784,10.784,0,0,1-5.026,6.343c-2.013,1.122-3.753,2.7-5.884,3.64-2.362-.4-4.422-.284-5.785,2.223-.608,1.118-2.1.932-3.294.956-4.7-1.3-7.668,1.392-10.413,4.548-.834.96-1.364,2.229-2.771,2.571a21.789,21.789,0,0,1-5.168.157,6.024,6.024,0,0,0-5.16,1.851,18.963,18.963,0,0,1-8.55.055c-.241-.132-.546-.226-.677-.463-2.425-4.4-6.444-4.98-10.933-4.766a72.708,72.708,0,0,1-9.689-.061c-4.137-.356-6.2-4.247-4.216-7.738a7.273,7.273,0,0,1,3.52-.513c9.585.038,19.17-.12,28.755.077a6.17,6.17,0,0,0,2.716-.344c5.271-1.869,6.966-4.847,5.893-10.838-1.7-9.472-3.36-18.95-5.094-28.415-1.383-7.554-2.781-15.106-4.129-22.666-1.1-6.169-3.486-8.274-9.728-8.307-24.716-.132-49.431-.026-74.148-.068a11.379,11.379,0,0,0-4.324.809c-3.137,1.214-4.442,3.761-3.809,7.815.865,5.533,1.958,11.029,2.955,16.54.344,1.9.639,3.8,1.032,5.688.4,2.2.7,4.422,1.2,6.607.369,2.045.646,4.106,1.112,6.134.371,2.038.646,4.094,1.111,6.115.155,1.623.722,3.18.778,4.819.812,3.261,1.145,6.615,1.913,9.886a5.99,5.99,0,0,0,1.878,3.53c1.993,2.116,4.576,2.625,7.313,2.654,4.786.05,9.572,0,14.357.027,1.275.008,2.594-.147,3.754.609,1.318,2.043.46,4.334.738,6.493a8.227,8.227,0,0,0,.752,2.867c.15.253.28.512.412.775.425,1,2.009,2.078-.169,2.936a16.114,16.114,0,0,1-3.867.246q-35.2.01-70.405-.015c-1.614,0-3.366.4-4.732-.952a100.953,100.953,0,0,1-12.93-27.686,57.9,57.9,0,0,1-2.475-11.556c-.3-4.353-.921-8.679-.333-13.179a72.036,72.036,0,0,1,3.467-15.83,61.406,61.406,0,0,1,10.715-18.23c5.125-6.123,11.517-10.455,18.331-14.405,2.872-1.665,6.185-2.424,8.782-4.567,1.14-1.11,2.59-.81,3.944-.812q27.984-.028,55.969-.014c3.962,0,4.2-.173,4.184-4.235C4937.526,1312,4937.828,1303.333,4937.307,1294.672Z",
				transform: "translate(-4022.232 -924.392)",
				fill: "#e7f3fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4752",
				"data-name": "Path 4752",
				d: "M5035.776,1415.332a4.505,4.505,0,0,1,1.161,3.542c-.045,7.945-.015,15.89-.026,23.835,0,3.251-.409,3.652-3.7,3.653q-29.25.01-58.5,0c-.924,0-1.848.015-2.772.023-2.771-.284-2.8-.284-2.807-2.892-.018-6.058,0-12.116,0-18.174a5.02,5.02,0,0,1-.652-1.716,13.86,13.86,0,0,1-.077-1.425c-.081-.994.022-1.991-.094-2.986.225-4.116.754-4.674,4.763-4.677q23.167-.02,46.334,0a3.284,3.284,0,0,1,2.027.738Z",
				transform: "translate(-4120.699 -1045.051)",
				fill: "#9ec8ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4753",
				"data-name": "Path 4753",
				d: "M4930.926,1370.7q.02.882.037,1.765a4.6,4.6,0,0,0-2.933-.576c-3.329.006-6.658.031-9.987-.009-2.274-.027-2.567-.3-2.575-2.577q-.042-12.757,0-25.514c.007-2.111.338-2.428,2.4-2.466,2.681-.05,5.364-.014,8.045-.014h52.989c.647,0,1.3-.023,1.941.007,2.046.094,2.355.368,2.374,2.5.038,4.437.009,8.874.013,13.312,0,1.756.018,3.512.027,5.268l-1.76,0c-1.549-2.58-.682-5.42-.779-8.131-.146-4.019-.215-4.275-4.188-4.278q-27.035-.021-54.071,0c-3.7,0-3.893.227-3.927,3.932-.04,4.434.065,8.869-.055,13.3a3.335,3.335,0,0,0,.414,2.127c2.229,1.3,4.66.359,6.978.634C4927.564,1370.189,4929.373,1369.538,4930.926,1370.7Z",
				transform: "translate(-4082.535 -992.196)",
				fill: "#b7e1ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4800",
				"data-name": "Path 4800",
				d: "M5592.732,1571.54a3.5,3.5,0,0,1,2.214-2.3c5.122-2.333,10.223-4.711,15.345-7.043,3.1-1.413,6.236-2.767,9.353-4.155a7.472,7.472,0,0,1,2.563-1c.752-.019.89.559,1.073,1.094.162.805.256,1.623.435,2.431.761,3.442,2.022,4.182,5.467,3.1,4.58-1.44,7.506-4.74,9.78-8.759.345-.609.293-1.48,1.16-1.741a151.752,151.752,0,0,0,22.821,12.872c3.671,1.7,7.345,3.4,11.157,4.776a9.3,9.3,0,0,1,5.826,5.055c3.764,8.473,5.368,17.459,6.313,26.6.5,4.88.868,9.74.018,14.649-.982,5.675-3.489,7.748-9.132,6.919a37.886,37.886,0,0,0-10.437.307c8.026-1.605,18.106,4.618,20.391,13.523,1.213,4.731-1,8.784-6.006,10.732-3.847,1.5-7.955,1.609-12,2-10.4,1.009-20.839,1.364-31.279,1.6a5.9,5.9,0,0,1-1.365.1c-3.684.041-3.668.047-2.548-3.405a14.577,14.577,0,0,0,.086-7.846c-.557-2.442-2.177-3.358-4.979-3.265a18.374,18.374,0,0,0-3.469.81,2.05,2.05,0,0,1-1.7-.312c-.014-1.9,1.663-1.98,2.816-2.478a157.566,157.566,0,0,1,25.1-7.909c4.1-1.007,4.041-1.029,4.118-5.149.108-5.824-.752-11.6-.614-17.437.2-8.487,1.324-16.75,4.654-24.622a13.743,13.743,0,0,1,2.764-4.765c-7.893,7.7-12.007,19.288-13.264,30.118-1.089,9.379-5.533,16.228-12.853,21.666a128.774,128.774,0,0,1-18.775,11.768,6.466,6.466,0,0,1-3.43.959,2.686,2.686,0,0,1-1.266-.455c-2.171-3.028-3.58-6.47-5.166-9.8-3.859-8.1-7.713-16.215-10.541-24.76a90.566,90.566,0,0,1-4.369-24.506C5592.848,1577.792,5592.3,1574.683,5592.732,1571.54Z",
				transform: "translate(-4571.441 -1145.177)",
				fill: "#7284fa"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4801",
				"data-name": "Path 4801",
				d: "M5067.826,1678.808c-6.235-.01-12.471.026-18.705-.05-2.892-.036-5.686-.5-7.423-3.262-2.228-3.59-2-7.811-2.987-11.721a6.381,6.381,0,0,0-.544-1.8c.264-1.648-.632-3.148-.6-4.766a50.719,50.719,0,0,1-1.108-6.058c-.615-1.928-.668-3.962-1.107-5.921-.7-2.264-.587-4.7-1.443-6.935-.956-2.291-1.068-4.775-1.561-7.165-.978-4.737-1.556-9.555-2.54-14.29a11.424,11.424,0,0,1,.909-7.2,2.774,2.774,0,0,1,3.214-1.933,13.362,13.362,0,0,1,4.627-.554q34.941,0,69.881.005c6.289,0,9.441,2.367,10.656,8.6,3.4,17.411,6.65,34.849,9.917,52.286a8.74,8.74,0,0,1-2.689,8.582c-.657.6-1.031,1.059-.1,1.677-.95.844-2.109.5-3.178.5-9.76.013-19.52-.014-29.28-.02-1.012,0-2.023.054-3.036.083-1.227-1.071-.905-2.538-.915-3.875-.048-6.723.015-13.446-.036-20.169-.029-3.854-1.552-6.771-5.379-8.137a24.862,24.862,0,0,0-9.892-.184c-3.821.583-5.822,3.371-5.87,7.58-.079,7.019,0,14.04-.041,21.059C5068.588,1676.4,5068.9,1677.758,5067.826,1678.808Z",
				transform: "translate(-4164.934 -1184.157)",
				fill: "#a8ceff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4802",
				"data-name": "Path 4802",
				d: "M5215.208,1793.578a4.61,4.61,0,0,1-.551.068c-12.3.073-24.589.618-36.893.464a15.945,15.945,0,0,1-7.561-2.271c-.437-.763-1.311-1.217-1.519-2.142.161-.121.256-.316.137-.461-.233-.284.121-.008-.25-.008-.714-.62-.685-1.551-.982-2.345.441-5.6.107-11.21.179-16.815.06-4.6.007-9.2.014-13.806.008-6.192,3.1-9.244,9.378-9.262q1.519,0,3.039,0c4.04-.182,6.291,2.18,7.757,5.553a14.749,14.749,0,0,1,.936,5.986q-.006,13.031,0,26.063c.007,4.9,1.442,6.4,6.432,6.512,5.175.12,10.357-.1,15.53.107C5212.561,1791.29,5214.729,1791.021,5215.208,1793.578Z",
				transform: "translate(-4264.59 -1285.121)",
				fill: "#a8ceff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4803",
				"data-name": "Path 4803",
				d: "M5628.888,1401.882a17.944,17.944,0,0,1-.177-7.905c.327-2.068.355-3.717-1.321-5.218a8.01,8.01,0,0,1-2.09-3.548,2.282,2.282,0,0,1,1.7-3.2c5.684-1.561,11.191-3.758,17.058-4.673a24.02,24.02,0,0,1,7.157-.214,12.1,12.1,0,0,1,7.74,3.888,6.854,6.854,0,0,0,3.3,2.271c2.264.691,3.367,2.751,3.891,5.014a21.324,21.324,0,0,1-.585,12.256,118.738,118.738,0,0,0-4.857,14.907c-3.583-1.147-4.727-4.273-2.5-6.9a8.273,8.273,0,0,0,1.9-6.2,2.519,2.519,0,0,0-1.764-2.572c-1.4-.335-2.314.589-2.879,1.692-1.206,2.357-.879,4.864-.406,7.332.347,1.812.995,3.582.517,5.469a33.814,33.814,0,0,1-1.188,4.559,9.288,9.288,0,0,1-9.39,5.95,14.642,14.642,0,0,0-2.449.205c-7.751,1.953-12.191-2.343-13.387-9.126a11.855,11.855,0,0,1-.153-4.378.6.6,0,0,1,.776.039c1.079,1.139,1.115,2.7,1.638,4.069,1.361,3.559,2.721,4.431,6.5,4.116a14.839,14.839,0,0,0,6.833-2.039c5.608-3.511,7.185-6.922,5.643-13.3a33.307,33.307,0,0,1-1.075-7.9c0-2.764-1.069-3.457-3.434-2.111a11.864,11.864,0,0,1-11.673.38c-2.206-1.072-2.886-.234-3.486,1.732C5630.163,1398.294,5630.428,1400.4,5628.888,1401.882Z",
				transform: "translate(-4594.949 -1017.929)",
				fill: "#2e5b9a"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4804",
				"data-name": "Path 4804",
				d: "M5488.662,1703.307a81.894,81.894,0,0,1,7.241-5.035,6.722,6.722,0,0,0,2.536-3.132,167.119,167.119,0,0,0,5.293-16.836c3.5-12.2,6.913-24.422,11.144-36.4a6.064,6.064,0,0,1,.529-.939c1.066,1.033.856,2.389.865,3.656.038,5.456-.014,10.913.023,16.368.068,10.081,1.042,20.105,1.99,30.129a67.666,67.666,0,0,1,.105,10.8c-.261,3.97-2.4,7.126-4.89,10.052a4.415,4.415,0,0,1-4.036,1.369c-1.533-.192-2.651-1.18-3.851-2.022a50.845,50.845,0,0,0-8.39-5.26,17.436,17.436,0,0,0-6.755-1.1C5489.544,1704.761,5488.7,1704.467,5488.662,1703.307Z",
				transform: "translate(-4496.418 -1208.569)",
				fill: "#7284fa"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4805",
				"data-name": "Path 4805",
				d: "M5560.636,1696.994c2.646.441,4.169-.888,5.645-2.979a17.856,17.856,0,0,0,3.37-11.114,142.318,142.318,0,0,0-1.065-14.547c-.313-2.542-.351-5.12-.59-7.684-.887-9.555-.594-19.151-.622-28.734q-.01-3.324-.029-6.648a37.383,37.383,0,0,1,2.3-6.037c.148.228.426.457.425.684-.014,2.857.486,5.683.592,8.52a88.3,88.3,0,0,0,6.242,29.8c3.638,9.078,7.744,17.948,12.2,26.654a7.805,7.805,0,0,1,1.069,2.538c-2.876,1.016-5.792.374-8.611-.078-8.329-1.336-8.949-1.07-12.143,6.776-.549,1.347-.9,2.825-2.2,3.747a9.948,9.948,0,0,1-6.283-.045A.7.7,0,0,1,5560.636,1696.994Z",
				transform: "translate(-4548.355 -1192.888)",
				fill: "#6074f5"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4806",
				"data-name": "Path 4806",
				d: "M5638.666,1442.5a28.59,28.59,0,0,1,2.617-9.308,24.531,24.531,0,0,0,5.105,2.336,9.925,9.925,0,0,0,8.25-.9c4.174-2.371,5.289-1.669,5.309,3.192.008,2.053-.137,3.975.86,6.1a12.92,12.92,0,0,1,.616,6.784,8.012,8.012,0,0,1-1.668,4.037c-3.512,4.406-8.259,6.362-13.741,6.564a4.869,4.869,0,0,1-4.52-2.667,29.058,29.058,0,0,1-2.256-6.5c-.379-.575-.062-1.324-.473-1.892Q5638.717,1446.374,5638.666,1442.5Z",
				transform: "translate(-4604.727 -1058.547)",
				fill: "#f09959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4807",
				"data-name": "Path 4807",
				d: "M5754.658,1710.943c.875-.768,1.948-.518,2.926-.465,5.455.3,10.859-.556,16.3-.7,4.57-.119,9.147-.75,13.733-1.038a55.61,55.61,0,0,0,8.167-1.186,10.679,10.679,0,0,0,5.384-2.685,7.513,7.513,0,0,0,1.677-9.3,23.643,23.643,0,0,0-8.979-9.924c-3.632-2.316-7.726-2.118-11.8-1.6-.453.057-.893.207-1.346.264-.153.02-.327-.116-.738-.278a22.456,22.456,0,0,1,6.981-1.876,24.225,24.225,0,0,1,8.964.407c2.414.594,4.7-.891,5.777-3.3.962-2.149,1.028-4.5,1.265-6.745.485-4.591-.266-9.182-.773-13.75a119.891,119.891,0,0,0-5.206-23.091,3,3,0,0,1-.024-.829c1.915,1.561,2.352,3.944,3.141,6.052a97.2,97.2,0,0,1,4.644,18.723c.876,5.438,1.792,10.871,2.622,16.316.318,2.087.472,4.2.66,6.3.5,5.579.8,11.177,1.613,16.725.767,5.26-1.07,8.451-6.11,10.3-1.79.658-3.645,1.137-5.47,1.7-12.616.671-25.243.666-37.871.6a7.8,7.8,0,0,1-1.091-.157C5757.652,1710.945,5756.07,1711.747,5754.658,1710.943Z",
				transform: "translate(-4688.477 -1204.151)",
				fill: "#6074f5"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4808",
				"data-name": "Path 4808",
				d: "M5137.533,1676.478h-2.786c.05-.3.021-.528.107-.584,4.6-2.969,5.458-5.143,4.435-10.474-1.942-10.118-3.8-20.251-5.692-30.378-1.316-7.052-2.5-14.132-3.986-21.15-1.039-4.917-3.358-8-9.934-8l-74.438-.009c1.364-1.182,3.02-1.189,4.69-1.188q21.5.009,42.991,0c10.817,0,21.638.142,32.451-.071a8.784,8.784,0,0,1,8.865,7.106c1.184,6.8,2.514,13.57,3.755,20.359s2.443,13.586,3.674,20.378c.8,4.437,1.693,8.86,2.423,13.308.785,4.786-.767,8.154-4.443,10.1A4.593,4.593,0,0,1,5137.533,1676.478Z",
				transform: "translate(-4176.25 -1182.329)",
				fill: "#75a1de"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4809",
				"data-name": "Path 4809",
				d: "M5425.548,1898.765l6.311-.012a4.293,4.293,0,0,0,6.351,1.271c.925-.587,1.632-1.51,2.765-1.782a2.812,2.812,0,0,1,1.957.228c.452,1.194.668,2.227,2.414.943,2.749-2.02,6-1.208,8.377,1.667-.525,1.922-1.941,2.561-3.764,2.61-.462.013-.923,0-1.385,0q-35.461,0-70.922,0a10.981,10.981,0,0,1-2.209-.074c-1.364-.284-2.425-.946-2.319-2.594.736-2.281.736-2.3,2.95-2.325,2.564-.025,5.13,0,7.7,0,1.758.9,3.372.21,4.99-.457a5.9,5.9,0,0,1,2.52.1c6.235,1.01,12.458.548,18.679-.143a19.406,19.406,0,0,1,3.72-.234c1.809.055,3.618-.015,5.423.058a7.525,7.525,0,0,1,3.662.956A2.374,2.374,0,0,0,5425.548,1898.765Z",
				transform: "translate(-4412.988 -1394.127)",
				fill: "#75a0dd"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4810",
				"data-name": "Path 4810",
				d: "M5709.793,1470.894a13.891,13.891,0,0,0-.7-5.173,14.078,14.078,0,0,1-.286-6.035,4.542,4.542,0,0,1,2.3-3.595,2.711,2.711,0,0,1,4.246,1.433,8.2,8.2,0,0,1-2.423,8.756c-1.1.826-1.217,1.3-.459,2.375a14.269,14.269,0,0,0,3.007,3.575l2.93,10.468c.095,2.36-1.59,3.834-2.839,5.475a14.61,14.61,0,0,1-8.409,5.838,12.822,12.822,0,0,1-2.729.208,2.437,2.437,0,0,1-2.729-2.173c-.207-1.445-.854-2.823-.679-4.324,4.438-.959,6.553-4.129,7.379-8.212A52.835,52.835,0,0,0,5709.793,1470.894Z",
				transform: "translate(-4649.73 -1074.703)",
				fill: "#f09959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4811",
				"data-name": "Path 4811",
				d: "M5248.252,1792.63c-1.228-1.579-3-1.6-4.747-1.612-5.087-.026-10.176-.016-15.264-.008a10.151,10.151,0,0,1-3.273-.428c-3.049-1.007-3.884-2.041-3.887-5.172q-.012-14.426-.009-28.852a10.9,10.9,0,0,0-1.758-6.554,7.283,7.283,0,0,0-5.958-3.44c1.112-1.47,2.532-.711,3.871-.531a7.554,7.554,0,0,1,6.086,7.739c.065,7.175.018,14.351.027,21.526,0,1.195.056,2.389.086,3.583a18.108,18.108,0,0,0-.034,2.218,4.441,4.441,0,0,0,4.754,4.4c3.98.051,7.967.129,11.942-.017,4.3-.158,7.39,1.323,8.78,5.6C5248.769,1791.637,5249.061,1792.351,5248.252,1792.63Z",
				transform: "translate(-4297.637 -1284.172)",
				fill: "#75a1de"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4812",
				"data-name": "Path 4812",
				d: "M5236.925,1478.057c-.567-4.021,4.065-9.182,8.555-8.972,5.244.245,9.263,3.9,9.22,8.979a9.025,9.025,0,0,1-8.808,8.844C5240.035,1486.945,5236.577,1481.909,5236.925,1478.057Z",
				transform: "translate(-4314.621 -1084.458)",
				fill: "#2cd5c4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4813",
				"data-name": "Path 4813",
				d: "M5455.684,1872.756c-1.914.972-3.958.276-5.936.444-1.347.114-2.736-.193-3.839,1a1.044,1.044,0,0,1-1.687.017c-.856-1.168-2.075-.928-3.25-1.011-1.435-.1-2.931.4-4.3-.407.834-.966,1.987-.714,3.045-.768,3.081-.158,4.494-2.849,2.916-5.609a1.3,1.3,0,0,1-.26-.74c1.492,0,2.747-.192,3.636-1.751,1.36-2.386,1.738-2.384,4.334-1.293a6.108,6.108,0,0,0,.781.215,2.8,2.8,0,0,0,1.807,1.161,5.144,5.144,0,0,1,.508.213c1.276.646,3.237,1.172,2.618,2.911-.606,1.7-2.458,1.008-3.9.692a3.175,3.175,0,0,0-3.928,3.29c.027,1.255.942.832,1.585.912C5451.771,1872.273,5453.86,1871.436,5455.684,1872.756Z",
				transform: "translate(-4458.881 -1368.113)",
				fill: "#f7a96f"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4814",
				"data-name": "Path 4814",
				d: "M5424.155,1874.162c.235.133.467.371.708.381,1.545.057,1.556.818,1.1,2.021a7.622,7.622,0,0,0-.749,3.2c.069,1.052-.5,1.473-1.517,1.471-1.747,0-3.5.031-5.244.05a.587.587,0,0,1-.4-.108c-.418-1.112.8-1.548,1.01-2.405-1.02.655-1.5,1.908-2.683,2.361a4.244,4.244,0,0,1-3.694,1.229,1.3,1.3,0,0,1-1.244-1.188,40.518,40.518,0,0,1,3.948-4.6C5417.916,1874.214,5420.67,1872.918,5424.155,1874.162Z",
				transform: "translate(-4440.66 -1376.596)",
				fill: "#ef9a5b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4815",
				"data-name": "Path 4815",
				d: "M5706.6,1510.707c.446,3.036-.154,6.034-.633,8.979-.624,3.83-3.183,6.461-6.382,8.525-1.039.671-1.205-.377-1.756-.676-.173-.384-.085-.889-.529-1.148.113-1.721-.651-3.315-.729-5.008.787-.744,1.867-.754,2.813-1.007,3.948-1.057,5.9-3.774,6.7-7.579C5706.227,1512.093,5705.993,1511.292,5706.6,1510.707Z",
				transform: "translate(-4646.537 -1114.515)",
				fill: "#e28541"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4816",
				"data-name": "Path 4816",
				d: "M5183.818,1745.52c-1.282.239-2.693-.456-3.872.531-1.295.011-2.591.009-3.887.036-5.048.107-8.325,3.35-8.348,8.392-.043,9.344-.007,18.688-.043,28.032,0,.972.387,2.048-.443,2.909q-.054-3.556-.107-7.111c0-8.112.129-16.226-.03-24.334-.1-5.2,3.389-9.319,9.136-8.992,1.839.1,3.688.009,5.532.02C5182.48,1745.009,5183.251,1744.871,5183.818,1745.52Z",
				transform: "translate(-4264.227 -1283.659)",
				fill: "#83ace6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4817",
				"data-name": "Path 4817",
				d: "M5060.176,1804.449c1.118,2.116,1.188,4.5,1.607,6.776.4,2.152.69,4.273,1.938,6.136.046.068-.144.292-.224.445a4.143,4.143,0,0,1-1.7-2.98c-.689-3.458-1.361-6.919-2.04-10.379Q5059.971,1804.057,5060.176,1804.449Z",
				transform: "translate(-4186.734 -1326.466)",
				fill: "#9ac0f0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4818",
				"data-name": "Path 4818",
				d: "M5045.159,1719.191c1.231.849.811,2.286,1.062,3.422.23,1.048.492,2.122.649,3.2-.192.258-.383.245-.573,0A25.726,25.726,0,0,1,5045.159,1719.191Z",
				transform: "translate(-4176.191 -1265.048)",
				fill: "#9dc2f2"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4819",
				"data-name": "Path 4819",
				d: "M5049.25,1743.015h.573q.554,3.055,1.109,6.11c-.189.257-.377.244-.566,0A27.675,27.675,0,0,1,5049.25,1743.015Z",
				transform: "translate(-4179.145 -1282.25)",
				fill: "#9bc0f1"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4820",
				"data-name": "Path 4820",
				d: "M5053.267,1764.995h.566l1.115,6.108q-.292.375-.582,0A28.049,28.049,0,0,1,5053.267,1764.995Z",
				transform: "translate(-4182.047 -1298.121)",
				fill: "#99bff0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4821",
				"data-name": "Path 4821",
				d: "M5057.223,1786.973h.582c.095,1.676.855,3.279.54,5l-.417,0Q5057.576,1789.471,5057.223,1786.973Z",
				transform: "translate(-4184.902 -1313.99)",
				fill: "#99bff0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4822",
				"data-name": "Path 4822",
				d: "M5639.022,1494.551a1.864,1.864,0,0,1,.473,1.892l-.466-.028Q5639.026,1495.483,5639.022,1494.551Z",
				transform: "translate(-4604.984 -1102.85)",
				fill: "#676b8a"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4823",
				"data-name": "Path 4823",
				d: "M5171.124,1898.319a3.6,3.6,0,0,1,.352-.24c.3.355.068.547-.239.709A2.387,2.387,0,0,1,5171.124,1898.319Z",
				transform: "translate(-4267.143 -1394.212)",
				fill: "#8bb1e6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4911",
				"data-name": "Path 4911",
				d: "M5592.741,1869.911c-.605.558-1.226,1.1-1.814,1.677-1.75,1.708-3.9,1.421-5.958,1.027-1.319-.253-1.547-1.389-1.085-2.606,1.265-2.844,2.18-5.827,3.754-8.553,1.622-2.81,3.987-3.838,6.957-3.047,4.029,1.073,8.2.731,12.24,1.536l.961.135c1.89.406,3.9.247,5.677,1.195a13.87,13.87,0,0,0,4.625,1.8,3.341,3.341,0,0,1,.727.531c.106.114.2.23.31.343,1.4,1.9,1.4,4.052.981,6.218-.177.905-.278,2.052-1.637,2.131a35.762,35.762,0,0,1-11.1.049,10.506,10.506,0,0,0-1.634-.014q-2-.927-4-1.855a3.426,3.426,0,0,0-4.073.686c-.136.125-.263.26-.4.381-.771.675-1.7,1.578-2.644.833-1.021-.805.5-1.527.536-2.374-.126-.559.232-1.049.23-1.764C5594.264,1868.49,5593.727,1869.6,5592.741,1869.911Z",
				transform: "translate(-4565.014 -1365.382)",
				fill: "#f09959"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4912",
				"data-name": "Path 4912",
				d: "M5708.911,1879.738a7.948,7.948,0,0,0,.014-8.413c1.008-1.5,3.035-1.527,4.15-2.876a9.656,9.656,0,0,1,1.994,10.276,2.7,2.7,0,0,1-1.154,1.307C5712.242,1880.037,5710.525,1880.76,5708.911,1879.738Z",
				transform: "translate(-4655.445 -1372.819)",
				fill: "#a46b4b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4913",
				"data-name": "Path 4913",
				d: "M5715.356,1870.138a1.414,1.414,0,0,1,.507-1.021c3.143-2.356,2.887-5.713,2.533-9.014-.275-2.564-1.66-3.3-5.913-3.5a2.126,2.126,0,0,1-1.577-.706c1.739-1.376,3.788-1.2,5.78-1.04,1.48.121,3.359,2.274,3.6,4.08a21.676,21.676,0,0,1,.024,7.3,11.773,11.773,0,0,1-1.586,3.078c1.5.766,2.955.338,4.347.407,1.464.3,3.031-.353,4.439.471Z",
				transform: "translate(-4656.889 -1362.925)",
				fill: "#6074f5"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4946",
				"data-name": "Path 4946",
				d: "M5009.073,1468.324H4981.03c-.556,0-1.111.018-1.666,0-1.932-.081-2.086-.185-2.143-2.043-.061-1.941-.017-3.885-.017-5.828,0-3.608-.024-7.216.009-10.824.022-2.4.078-2.463,2.543-2.466q18.187-.023,36.374-.007,11.106,0,22.212,0c2.789,0,2.81.025,2.818,2.729.015,5.366.023,10.732-.006,16.1-.012,2.247-.091,2.328-2.373,2.333Q5023.928,1468.346,5009.073,1468.324Z",
				transform: "translate(-4127.115 -1068.624)",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4947",
				"data-name": "Path 4947",
				d: "M4923.81,1390.526c-.766-.641-.531-1.528-.534-2.332q-.025-8.051,0-16.1c.008-2.658.029-2.678,2.847-2.679q27.773-.01,55.547,0c1.111,0,2.224-.043,3.333.013,1.763.089,2.118.39,2.142,2.159.049,3.7,0,7.4-.008,11.1l-40.663.063c-1.844,0-3.689.02-5.533,0-4.837-.062-4.35.081-4.351,4.385-.616,1.364-1.875,1.286-3.053,1.322-2.1.064-4.2,0-6.3.037-1.082.019-2.039.195-2.036,1.6A.837.837,0,0,1,4923.81,1390.526Z",
				transform: "translate(-4088.164 -1012.481)",
				fill: "#feffff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4948",
				"data-name": "Path 4948",
				d: "M4927.539,1436.035c-1.082-1.958-1.006-2.193,1.033-2.247,2.567-.068,5.138-.023,7.707-.016a4.6,4.6,0,0,0,2.911-.572l-.023,2.875A27.675,27.675,0,0,1,4927.539,1436.035Z",
				transform: "translate(-4090.766 -1058.553)",
				fill: "#b2eae4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4949",
				"data-name": "Path 4949",
				d: "M4926.407,1443.4l11.627.039q0,.493-.008.984-5.491.031-10.979.062a2.01,2.01,0,0,1-1.767-.524A1.237,1.237,0,0,0,4926.407,1443.4Z",
				transform: "translate(-4089.633 -1065.916)",
				fill: "#ecf6ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4976",
				"data-name": "Path 4976",
				d: "M5676.021,1696.287a25.947,25.947,0,0,1-5.543-1.726c2.6-.208,4.694-1.693,6.826-2.912a120.047,120.047,0,0,0,14.6-9.492c3.919-3.072,7.586-6.381,10.121-10.829,1.569-2.754,1.977-5.73,2.42-8.7a74.2,74.2,0,0,1,7.391-23.912,28.277,28.277,0,0,1,8.584-9.8,39.569,39.569,0,0,0-4.758,9.861,60.762,60.762,0,0,0-2.9,13.158,83.488,83.488,0,0,0-.384,15.48c.2,3.958.443,7.91.451,11.873.005,2.861-.009,2.864-2.941,3.575a204.736,204.736,0,0,0-19.937,5.674c-3.372,1.19-6.838,2.233-9.873,4.237a1.584,1.584,0,0,1-.993.827,1.309,1.309,0,0,1-.652,0,1.283,1.283,0,0,1-.362-.368c-.047.176.053.353,0,.53a2.787,2.787,0,0,1-.612.831C5676.843,1695.046,5676.81,1695.987,5676.021,1696.287Z",
				transform: "translate(-4627.697 -1199.864)",
				fill: "#6074f5"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4977",
				"data-name": "Path 4977",
				d: "M5700.81,1859.2c.272-.432.73-.464,1.167-.546l1.639.063,1.723.086a.927.927,0,0,1-.054,1.2,1.893,1.893,0,0,1-.818.306C5703.179,1860.171,5701.82,1860.257,5700.81,1859.2Z",
				transform: "translate(-4649.598 -1365.747)",
				fill: "#8d9db0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4978",
				"data-name": "Path 4978",
				d: "M5483.113,1877.742h-8.45a10.23,10.23,0,0,1,1.293-4.557c.766-1.655,1.239-1.82,3.076-1.335a12.705,12.705,0,0,1,1.835.615,2.017,2.017,0,0,0,2.468-.634c-.615-1.384-2.4-1.487-2.974-2.832a13.713,13.713,0,0,1,9.436,2.115,96.632,96.632,0,0,1,8.793,6.093c.093.177.185.354.279.531.072,1.717-.085,1.915-1.4,1.584-1.5-.379-2.715-1.518-4.306-1.684-2.05-.508-4.1-1.528-6.146.021Z",
				transform: "translate(-4486.311 -1373.099)",
				fill: "#f0995a"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4979",
				"data-name": "Path 4979",
				d: "M5519.12,1895.7c.882-.38.861-1.871,1.693-1.876a8.841,8.841,0,0,1,3.089.982,8.388,8.388,0,0,1,1.364.874Z",
				transform: "translate(-4518.41 -1391.139)",
				fill: "#b2d7e0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4980",
				"data-name": "Path 4980",
				d: "M5429.206,1890.889a5.811,5.811,0,0,1,4.362-3.689c-.565,1.8-2.2,2.364-2.69,3.733Z",
				transform: "translate(-4453.488 -1386.357)",
				fill: "#e5dfe1"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4981",
				"data-name": "Path 4981",
				d: "M5616.318,1893.589c.812-1.488,1.679-2.891,3.908-2.611a6.708,6.708,0,0,1-1.49,2.706Z",
				transform: "translate(-4588.592 -1389.06)",
				fill: "#9fc7d5"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4982",
				"data-name": "Path 4982",
				d: "M5258.586,1494.972c.976-1.1,1.87-2.16,2.829-3.159.5-.517,1.147-1.207,1.859-.433.56.608-.021,1.2-.471,1.663-1.1,1.127-2.234,2.215-3.325,3.347-1.007,1.047-1.906.959-2.763-.167-.055-.074-.131-.133-.181-.21-.509-.774-2.077-1.416-1.095-2.422s1.643.587,2.448,1.031C5257.969,1494.667,5258.053,1494.706,5258.586,1494.972Z",
				transform: "translate(-4327.793 -1100.309)",
				fill: "#f9fcf9"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5086",
				"data-name": "Path 5086",
				d: "M5697.268,1862.77a1.174,1.174,0,0,0,.482-.007c1.319-.19,1.814.485,1.788,1.706a2.094,2.094,0,0,1-1.946,2.141,5.115,5.115,0,0,0-2.018.579l.008.011a.991.991,0,0,0-.622-.33,6.318,6.318,0,0,1-4.54-1.765c.031-1.023.111-2.021,1.329-2.384a4.053,4.053,0,0,0,4.646,1.369,1.181,1.181,0,0,0,.518-.812A.718.718,0,0,1,5697.268,1862.77Z",
				transform: "translate(-4642.094 -1368.684)",
				fill: "#4469a4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5087",
				"data-name": "Path 5087",
				d: "M5706.751,1877.622a.542.542,0,0,1,.622.33Z",
				transform: "translate(-4653.885 -1379.435)",
				fill: "#a46b4b"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5088",
				"data-name": "Path 5088",
				d: "M5718.579,1861.762a3.03,3.03,0,0,0-1.788-1.705q.043-.512.087-1.024a17.154,17.154,0,0,1,2.215-.028c3.031.339,4.386,1.861,4.45,4.933a29.331,29.331,0,0,0,.024,3.047c.348,2.761-.884,4.4-3.455,5.183C5721.379,1868.437,5720.417,1865.035,5718.579,1861.762Z",
				transform: "translate(-4661.137 -1365.976)",
				fill: "#ef995a"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5143",
				"data-name": "Path 5143",
				d: "M4999.626,1511.311q7.345,0,14.693,0a4.307,4.307,0,0,1,2.674.492.959.959,0,0,1-.045,1.756,3.663,3.663,0,0,1-2.127.474q-15.387-.006-30.774,0a7.58,7.58,0,0,1-1.105-.051c-.7-.1-1.258-.447-1.308-1.2-.061-.909.54-1.33,1.361-1.417a18.566,18.566,0,0,1,1.938-.048Q4992.279,1511.307,4999.626,1511.311Z",
				transform: "translate(-4130.322 -1114.948)",
				fill: "#2e2b60"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5144",
				"data-name": "Path 5144",
				d: "M5091.161,1458.052c-4.983,0-9.967.011-14.95,0-2.095-.006-2.911-.439-2.731-1.454.279-1.586,1.607-1.249,2.654-1.25q15.089-.029,30.178,0c1.061,0,2.528-.287,2.567,1.311s-1.414,1.39-2.489,1.394C5101.313,1458.061,5096.237,1458.052,5091.161,1458.052Z",
				transform: "translate(-4196.623 -1074.519)",
				fill: "#2e2b60"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5145",
				"data-name": "Path 5145",
				d: "M5024.582,1486.525c-8.607,0-17.213.018-25.819-.026-.909,0-2.506.559-2.555-.764-.054-1.444,1.568-.865,2.448-.868q25.957-.059,51.914,0c.855,0,2.491-.631,2.406.878-.072,1.3-1.662.745-2.576.749C5041.793,1486.542,5033.188,1486.525,5024.582,1486.525Z",
				transform: "translate(-4140.848 -1095.767)",
				fill: "#2e2b60"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5146",
				"data-name": "Path 5146",
				d: "M5053.1,1476.006h-56.62c-.084-1.04.587-.926,1.1-.964.552-.041,1.109-.018,1.664-.018q25.521,0,51.039.01c.955,0,1.977-.236,2.845.33Z",
				transform: "translate(-4141.037 -1088.722)",
				fill: "#2e2b60"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5147",
				"data-name": "Path 5147",
				d: "M5135.928,1513.9a9.574,9.574,0,0,1-1.359-.14,1.2,1.2,0,0,1-.962-1.176,1.126,1.126,0,0,1,.81-1.272,4.243,4.243,0,0,1,3.179.146c.538.307.45.987.335,1.506C5137.679,1514.1,5136.693,1513.779,5135.928,1513.9Z",
				transform: "translate(-4240.055 -1114.779)",
				fill: "#2e2b60"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5148",
				"data-name": "Path 5148",
				d: "M5117.292,1514.018c-1-.018-2.115.151-2.106-1.4.007-1.361.953-1.319,1.9-1.336,1.739-.03,2.516.4,2.49,1.4C5119.552,1513.609,5118.87,1514.009,5117.292,1514.018Z",
				transform: "translate(-4226.754 -1114.926)",
				fill: "#2e2b60"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5162",
				"data-name": "Path 5162",
				d: "M5700.437,1861.191a1.408,1.408,0,0,0,.116.487,1.174,1.174,0,0,1-.147,1.176c-1.233.969-2.642.7-3.974.428-1.034-.211-1.943-.768-1.514-2.138l.485-.364a.356.356,0,0,1,.53-.195,4,4,0,0,0,.545-.026A12.848,12.848,0,0,1,5700.437,1861.191Z",
				transform: "translate(-4645.264 -1367.104)",
				fill: "#f7e7f2"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5163",
				"data-name": "Path 5163",
				d: "M5697.474,1860.155l-.53.193C5697.027,1860.03,5697.112,1859.717,5697.474,1860.155Z",
				transform: "translate(-4646.805 -1366.674)",
				fill: "#8d9db0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5176",
				"data-name": "Path 5176",
				d: "M5714.943,1865.822q.074-.588.147-1.176C5715.6,1865.108,5715.471,1865.49,5714.943,1865.822Z",
				transform: "translate(-4659.803 -1370.072)",
				fill: "#8d9db0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4953",
				"data-name": "Path 4953",
				d: "M4946.141,1350.771c.022,1-.47,1.361-1.337,1.379-1.026.021-1.462-.453-1.438-1.471.025-1.123.7-1.318,1.621-1.271C4945.935,1349.457,4946.195,1350.03,4946.141,1350.771Z",
				transform: "translate(-4102.691 -998.047)",
				fill: "#fbfcff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4954",
				"data-name": "Path 4954",
				d: "M4928.328,1350.6c.03,1.046-.333,1.575-1.263,1.516a1.4,1.4,0,0,1-1.453-1.588c.009-1,.672-1.143,1.472-1.13C4928,1349.409,4928.387,1349.889,4928.328,1350.6Z",
				transform: "translate(-4089.875 -998.04)",
				fill: "#f9fcff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4955",
				"data-name": "Path 4955",
				d: "M4964.081,1350.629a1.41,1.41,0,0,1-1.562,1.468c-.981.006-1.163-.633-1.162-1.446,0-.926.5-1.282,1.358-1.276C4963.551,1349.38,4964.139,1349.644,4964.081,1350.629Z",
				transform: "translate(-4115.684 -998.027)",
				fill: "#f9fcff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4956",
				"data-name": "Path 4956",
				d: "M5330.705,1273.288h22.752c.647,0,1.3-.031,1.942.01,1.978.127,2.723.77,2.745,2.7q.086,7.349,0,14.7c-.026,2.16-.9,2.965-3.042,3.127-.552.042-1.109.012-1.665.012h-45.5a17.7,17.7,0,0,1-1.941-.023c-1.831-.2-2.7-1-2.726-2.859-.073-4.991-.065-9.985-.008-14.977.022-1.916.779-2.612,2.752-2.667,2.4-.067,4.809-.019,7.213-.02Z",
				transform: "translate(-4362.516 -943.078)",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5152",
				"data-name": "Path 5152",
				d: "M5341.661,1311.176c-7.025,0-14.05.014-21.074-.021-.746,0-2.041.424-2.088-.647-.056-1.27,1.29-.984,2.142-.985q21.352-.025,42.7-.009c.369,0,.739.023,1.105.057a.752.752,0,0,1,.759.661c.064.568-.307.843-.813.881-.736.054-1.477.061-2.215.061Q5351.92,1311.18,5341.661,1311.176Z",
				transform: "translate(-4373.555 -969.233)",
				fill: "#9ec8ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5153",
				"data-name": "Path 5153",
				d: "M5342.321,1302.925c-7.022,0-14.045.014-21.067-.016-.858,0-2.36.386-2.365-.7-.007-1.434,1.564-.853,2.445-.855q20.789-.059,41.578-.028c.37,0,.741-.018,1.108.008.619.043,1.494-.087,1.452.822-.042.865-.906.757-1.531.758Q5353.131,1302.931,5342.321,1302.925Z",
				transform: "translate(-4373.834 -963.274)",
				fill: "#9ec8ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5154",
				"data-name": "Path 5154",
				d: "M5331.611,1285.6q-5.262,0-10.526,0c-.646,0-1.293,0-1.937-.047a1.13,1.13,0,0,1-1.173-.964c-.089-.813.5-1.134,1.194-1.222a13.354,13.354,0,0,1,1.658-.057q10.526,0,21.051,0c.46,0,.925-.015,1.383.021.787.061,1.52.306,1.554,1.233.04,1.1-.847,1.023-1.572,1.03-2.216.019-4.432.009-6.647.009Z",
				transform: "translate(-4373.17 -950.323)",
				fill: "#9ec8ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5155",
				"data-name": "Path 5155",
				d: "M5444.338,1336.293c-1.034.016-1.366-.593-1.326-1.568s.633-1.179,1.454-1.187c1.082-.01,1.407.577,1.356,1.557C5445.773,1336.048,5445.207,1336.315,5444.338,1336.293Z",
				transform: "translate(-4463.453 -986.593)",
				fill: "#a4caff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5156",
				"data-name": "Path 5156",
				d: "M5463.708,1334.971c.007,1.157-.606,1.378-1.428,1.388-.923.011-1.3-.457-1.3-1.339,0-.839.238-1.418,1.219-1.39C5463.2,1333.66,5463.687,1334.17,5463.708,1334.971Z",
				transform: "translate(-4476.432 -986.659)",
				fill: "#9fc9ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5157",
				"data-name": "Path 5157",
				d: "M5480.034,1335.16c.036.893-.489,1.23-1.355,1.219-.852-.01-1.4-.334-1.358-1.276a1.376,1.376,0,0,1,1.579-1.448C5479.907,1333.658,5480.069,1334.3,5480.034,1335.16Z",
				transform: "translate(-4488.229 -986.676)",
				fill: "#9fc9ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4755",
				"data-name": "Path 4755",
				d: "M5349.546,1263.349c2.777.994,2.8.994,2.808,3.636q.023,9.161,0,18.323c-.008,3.137-.528,3.64-3.784,3.643-12.127.011-24.255.053-36.381-.042a6.231,6.231,0,0,0-5.095,2.116c-2.425,2.629-5.048,5.078-8.116,8.128,0-3.03.018-5.377,0-7.725-.023-2.426-.04-2.431-2.48-2.47-1.017-.016-2.036,0-3.054,0-1.768-.968-2.21-2.545-2.2-4.436.043-5.543,0-11.086.022-16.629.015-3.367,1.111-4.464,4.5-4.467q24.952-.021,49.9-.01C5346.96,1263.414,5348.253,1263.372,5349.546,1263.349Z",
				transform: "translate(-4353.875 -935.913)",
				fill: "#d8d8dc"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4950",
				"data-name": "Path 4950",
				d: "M5000.762,1426.757c-.048,1.049-.655,1.458-1.622,1.474-.783.013-1.516-.053-1.566-1.084a1.39,1.39,0,0,1,1.4-1.67A1.473,1.473,0,0,1,5000.762,1426.757Z",
				transform: "translate(-4141.83 -1052.97)",
				fill: "#f2f9ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4951",
				"data-name": "Path 4951",
				d: "M4982.8,1425.605c.845.078,1.258.672,1.211,1.631-.05,1-.75,1.084-1.533,1.069-.972-.019-1.186-.615-1.181-1.439C4981.3,1425.955,4981.739,1425.542,4982.8,1425.605Z",
				transform: "translate(-4130.082 -1053.064)",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4952",
				"data-name": "Path 4952",
				d: "M5018.168,1426.833c.042.866-.252,1.427-1.221,1.436-.788.008-1.51-.062-1.556-1.085a1.4,1.4,0,0,1,1.436-1.636C5017.738,1425.475,5018.2,1425.911,5018.168,1426.833Z",
				transform: "translate(-4154.697 -1053.021)",
				fill: "#fafeff"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5149",
				"data-name": "Path 5149",
				d: "M4970.212,1398.952q-12.617,0-25.233,0c-.74,0-1.48,0-2.216-.043-.5-.027-.923-.267-.885-.828s.5-.735.984-.761c.646-.035,1.294-.029,1.94-.029q25.513,0,51.023,0c.738,0,1.477.028,2.213.074a.738.738,0,0,1,.74.683c.058.579-.333.826-.838.857-.737.045-1.477.047-2.216.047Q4982.968,1398.954,4970.212,1398.952Z",
				transform: "translate(-4101.617 -1032.622)",
				fill: "#b2eae4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5150",
				"data-name": "Path 5150",
				d: "M4969.926,1408.851c-8.686,0-17.372.015-26.058-.021-.934,0-2.605.458-2.592-.732.017-1.476,1.735-.881,2.71-.883q25.641-.059,51.284-.007c1.027,0,2.812-.493,2.839.825.032,1.511-1.749.77-2.681.778C4986.929,1408.88,4978.427,1408.851,4969.926,1408.851Z",
				transform: "translate(-4101.186 -1039.705)",
				fill: "#b2eae4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_5151",
				"data-name": "Path 5151",
				d: "M5036.208,1381.441c-5.075,0-10.15.016-15.225-.011-1.031-.005-2.59.337-2.525-1.241.056-1.343,1.543-.991,2.5-.992q15.5-.031,31,.007c.806,0,2.119-.458,2.114.993,0,1.23-1.143,1.24-2.083,1.241Q5044.1,1381.446,5036.208,1381.441Z",
				transform: "translate(-4156.912 -1019.516)",
				fill: "#b2eae4"
			})
		]
	})
});
export default SvgEmptyState1;
